<template>
  <div ref="body" class="section">
    <div  v-show="!showImage">
      <dl>
        <dt>
          <div class="container publicity">
            <div class="th item col-md-1">作者</div>
            <div class="th item col-md-1">学校</div>
            <div class="th item col-md-1">年级</div>
            <div class="th item col-md-3 one-row">参赛作品名</div>
            <div class="th item col-md-2">指导教师</div>
          </div>
        </dt>
        <dd v-for="(row, idx) in top">
          <div class="container publicity" :id="idx" :ref="idx">
            <div class="item col-md-1">{{row.username}}</div>
            <div class="item col-md-1 one-row">{{row.school}}</div>
            <div class="item col-md-1">{{groups[row.gid]}}</div>
            <div class="item col-md-3 one-row"><a style="cursor: pointer;" @click="showImageList(idx)"><u>{{row.name}}</u></a></div>
            <div class="item col-md-2 one-row" v-if="row.teacher">{{row.teacher}}</div>
            <div class="item col-md-2" v-else>无</div>
          </div>
        </dd><br/><br/><br/><br/><br/>
      </dl>
    </div>

    <div v-show="showImage">
      <a @click="backList"><h2>
        <u>
        <<- 返回作品列表</u>
      </h2></a>
      <div style="margin-top: 30px">
        <h1>作品名称:</h1>
        <h3>{{dataList.name}}</h3>
      </div>

     <div style="margin-top: 30px">
        <h1>封面图:</h1>
        <img :src="titleImage" alt="" class="titleImage"
                    oncontextmenu="return false;"
                    ondragstart="return false;"
                    oncopy="return false;"
                    onselect="return false"
        >
        </img>
      </div>
      <div class="awardMsg" style="margin-top: 30px">
        <h1 class="title">作品说明：</h1>
        <i>{{dataList.note}}</i>
      </div>
      <div style="margin-top: 30px">
        <h1>任务书:</h1>
        <img :src="task" alt=""
                    oncontextmenu="return false;"
                    ondragstart="return false;"
                    oncopy="return false;"
                    onselect="return false"
        >
        </img>
      </div>

      <h1 style="margin-top: 30px">设计图：</h1>
      <div id="imageList" style="overflow: hidden">
        <div class="imgList">
          <div class="imgBox" v-for="(value,index) in imgList">
            <img v-if="!('http://www.archirookies.com/assets/upload/null'==imgList[index])" :src="value"
                    oncontextmenu="return false;"
                    ondragstart="return false;"
                    oncopy="return false;"
                    onselect="return false"
            >
            </img>
          </div>
        </div>
        <div>
          <div class="imgMask" :style="positionTop" v-if="showBigImg" @click.stop="showBigImg=!showBigImg" ref="imgMask">
            <img class="prev imgPosition" @click.stop="prev" src="./../../static/prev.png">
            <div class="showImg imgPosition" @onmousewheel.prevent="rollImg">
              <img class="bigImg" :src="imgList[num]">
            </div>
            <img class="next imgPosition" @click.stop="next" src="./../../static/next.png">
          </div>
        </div>
      </div>

      <h1 v-if="dataList.video" style="position: relative"><span class="title">视频:</span></h1>
      <div v-if="dataList.video" class="info-img">
        <div class="player">
           <video-player  class="vjs-custom-skin"
                          ref="videoPlayer"
                          :playsinline="true"
                          :options="playerOptions"
                          @play="onPlayerPlay($event)"
                          @pause="onPlayerPause($event)"
           >
           </video-player>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import axios from 'axios'
  import { Loading } from 'element-ui'
  import { videoPlayer } from 'vue-video-player'

  export default {
    components: {
      videoPlayer
    },
    data () {
      return {
        showImage: false,
        curIndex: '',
        url: this.API,
        imgUrl: 'http://www.archirookies.com',
        groups: ['全部','大一','大二','大三'],
        top: [],
        showBigImg: false,
        num: 0,
        dataList: {},
        positionTop: '',
        playerOptions: {
          height: '360',
          autoplay: false,
          muted: false,
          loop: false,
          preload: 'auto',
          language: 'zh-CN',
          aspectRatio: '16:9',
          fluid: true,
          sources: [{
            type: 'video/mp4'
          }],
          poster: 'poster.jpg'
        }
      }
    },
    mounted () {
      this.curIndex = 0 // parseInt(this.$route.query.id)
      this._getData()
    },
    computed: {
      player () {
        return this.$refs.videoPlayer.player
      },
      titleImage () {
        return this.imgUrl + '/assets/upload/' + this.dataList.cover
      },
      task () {
        return this.imgUrl + '/assets/upload/' + this.dataList.spec
      },
      imgList () {
        let imgsArr = this.dataList.imgs_url == undefined ? [] : this.dataList.imgs_url.split(';')
        let result = []
        if (imgsArr.length == 0) {
          return result
        }
        for (var i = 0; i<imgsArr.length; i++) {
          result.push(`${this.imgUrl}/assets/upload/${imgsArr[i]}`)
        }
        return result
      }
    },
    methods: {
      onPlayerPlay (player) {
      },
      onPlayerPause (player) {
      },
      imgDirection () {
        this.positionTop = 'margin-top:' + (document.body.scrollHeight - 1500) + 'px'
      },
      backList () {
        this.showImage = false 
        console.log('cur ref', this.$refs[this.curIndex])
        console.log('cur index', this.curIndex)
        this.$nextTick( () => {
           document.getElementById(this.curIndex).scrollIntoView()
        })
      },
      showImageList (index) {
        this.curIndex = index
        this.dataList = this.top[index]
        this.showImage = true
        window.scrollTo(0, 0)
        if (this.dataList.video) this.playerOptions.sources[0].src = 'http://www.archirookies.com/assets/upload/' + this.dataList.video
        // console.log(this.dataList)
      },
      bigImg (index) {
        this.showBigImg = true
        this.num = index
        this.imgDirection()
      },
      prev () {
        if (this.num === 0) {
          this.num = 3
        }
        this.num--
        console.log(this.num)
      },
      next () {
        if (this.num === 3) {
          this.num = 0
        }
        this.num++
      },
      _getData: function () {
        let _t = this
        let ld = Loading.service({'fullscreen': true, 'text': '数据加载中，请稍后'})
        axios.post(_t.API + '/api/work/top100/')
          .then(function (resp) {
            if (resp.data.code == '0') {
              _t.top = resp.data.data
/*
              if (_t.curIndex != '') {
                _t.showImageList(_t.curIndex)
              }
*/
            } else {
              _t.$messagewarning(resp.data.msg)
              console.log(resp.data)
            }
            ld.close()
          })
          .catch(function (error) {
            console.log(error)
            ld.close()
          })
      },
      page: function (uri) {
        let _t = this
        _t.$router.push('/' + uri + '/')
      }
    }
  }
</script>

<style scoped>
  .container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    height: 60px;
    width: 100%;
    align-items: center;
  }

  .item {
    flex: 3;
    word-wrap: break-word;
    text-align: center;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid aliceblue;
  }

  html, body, #imageList {
    height: 100%;
    width: 100%;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  .titleImage{
    width: 100%;
    height: auto;
  }

  .imgList {
    margin: 0 auto;
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    position: relative;
  }

  .imgBox {
    width: 100%;
    height: 100%;
    margin-bottom: 50px;
    border: 1px solid;
    position: relative;
  }

  .imgBox img{
    width: 100%;
    height: auto;
  }

  .imgMask {
    position: absolute;
    /*margin-top: 800px;*/
    height: 40%;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 100;
    background: rgba(0, 0, 0, .6);
  }

  .imgPosition {
    bottom: -40%;
  }

  .showImg {
    height: auto;
    width: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border: 10px solid #fff;
  }

  .bigImg {
    width: 100%;
    height: 100%;
  }

  .prev {
    position: absolute;
    top: 50%;
    left: 10px;
    width: 100px;
    transform: translate(10px, -50%);
    z-index: 80;
  }

  .next {
    width: 100px;
    transform: translate(10px, -50%);
    position: absolute;
    top: 50%;
    right: 20px;
    z-index: 80;
  }

  a:link {color:#a3a3a3;}		/* 未被访问的链接 */
  a:visited {color:#FF00FF;}	/* 已被访问的链接 */
  a:hover {color:#9cbeec;}	/* 鼠标指针移动到链接上 */
  a:active {color:#9cbeec;}
  .section{
      padding: 30px calc((100% - 1024px) / 2) 0;
  }
  .th {
    font-size: 18px;
  }
  .col-md-1 {
    width: 150px;
  }
  .player {
    height: 500px;
    width: 800px;
    position: relative;
  }
  /deep/ .video-js {
    height: 100%;
    width: 100%;
    position: absolute;
  }
</style>



// WEBPACK FOOTER //
// Top.vue?8e425422